module.exports = __webpack_public_path__ + "static/media/dlOfficeUIPic.735936c4.png";